import { useContext, useEffect, useState } from 'react'
import { UIContext } from 'Context/UI'
import { useNavigate } from 'react-router-dom'

import Checkbox from 'Presentation/Components/Table/Cells/Checkbox'
import ColorfulAbbreviation from 'Presentation/Components/Table/Cells/ColorfulAbbreviation'
import DoubleLine from 'Presentation/Components/Table/Cells/DoubleLine'
import Switch from 'Presentation/Components/Table/Cells/Switch'

import { FILTERS } from '../Config'

const MOCK_DATA = [
	{
		checkbox: false,
		label: 'Curbside recyclable (CU)',
		description: 'สามารถนำกลับมาใช้ใหม่ได้',
		active: true,
		color: '#FA4F02',
	},
	{
		checkbox: false,
		label: 'Home compostable (HC)',
		description: 'ที่สามารถย่อยสลายได้',
		active: true,
		color: '#FCCC33',
	},
	{
		checkbox: false,
		label: 'Drop-off compostable (DC)',
		description: 'ย่อยสลายผ่านกระบวนการทางอุตสาหกรรม',
		active: true,
		color: '#FCCC33',
	},
	{
		checkbox: false,
		label: 'Biodegradable (B)',
		description: 'วัสดุที่ย่อยสลายได้ตามธรรมชาติ',
		active: true,
		color: '#29CE72',
	},
	{
		checkbox: false,
		label: 'Returnable (R)',
		description: 'สามารถนำกลับมาใช้ใหม่ได้',
		active: true,
		color: '#FA4F02',
	},
	{
		checkbox: false,
		label: 'Sustainable inks (SI)',
		description: 'หมึกที่ทำจากธรรมชาติเป็นหลัก ไม่ทำลายสิ่งเเวดล้อม',
		active: true,
		color: '#29CE72',
	},
	{
		checkbox: false,
		label: 'Responsible forestry (RF)',
		description: 'ใช้วัสดุจากป่าที่ปลูกตามกฎหมาย',
		active: true,
		color: '#FCCC33',
	},
	{
		checkbox: false,
		label: 'Plastic-free (PF)',
		description: 'ไม่มีส่วนผสมจากพลาสติก',
		active: true,
		color: '#29CE72',
	},
	{
		checkbox: false,
		label: 'Recycled content (RC)',
		description: 'มีส่วนผสมของวัสดุรีไซเคิล',
		active: true,
		color: '#FA4F02',
	},
]

const ViewModel = () => {
	const { setCustomContentToolbar, setShowContentToolbar } = useContext(UIContext)
	const [filters] = useState(
		FILTERS.map(f => {
			if (f.label.toLowerCase() === 'sustainability') {
				return {
					...f,
					isActive: true,
				}
			}

			return f
		})
	)
	const navigate = useNavigate()

	const onClickFilter = (idx: number) => {
		// Sustainability
		if (idx === 3) {
			return
		}
		// Certification
		else if (idx === 4) {
			navigate('/general/certification')
		} else {
			navigate('/general/production', { state: { filterIdx: idx } })
		}
	}

	const TABLE_CONFIGS: any = [
		{
			Header: () => <Checkbox value={false} />,
			accessor: 'checkbox',
			width: 25,
			minWidth: 25,
			disableSortBy: true,
			Cell: ({ value }: any) => <Checkbox value={value} />,
		},
		{
			Header: 'รหัส',
			accessor: 'abbreviation',
			width: 30,
			minWidth: 30,
			Cell: ({ row }: any) => (
				<ColorfulAbbreviation label={row.original.label} color={row.original.color} />
			),
		},
		{
			Header: 'ชื่อ',
			accessor: 'label',
			width: 450,
			minWidth: 450,
			Cell: ({ row }: any) => (
				<DoubleLine label={row.original.label} description={row.original.description} />
			),
		},
		{
			Header: 'ใช้งานอยู่',
			accessor: 'active',
			width: 100,
			minWidth: 100,
			Cell: ({ value }: any) => <Switch value={value} />,
		},
	]

	useEffect(() => {
		setShowContentToolbar(false)
		setCustomContentToolbar(null)

		return () => {
			setShowContentToolbar(true)
			setCustomContentToolbar(null)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return {
		filters,
		onClickFilter,
		data: MOCK_DATA,
		TABLE_CONFIGS,
	}
}

export default ViewModel
